import { render } from "./PreviousListingComponent.vue?vue&type=template&id=82dedb52"
import script from "./PreviousListingComponent.vue?vue&type=script&lang=js"
export * from "./PreviousListingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__